import { render } from "./ThemeSwitch.vue?vue&type=template&id=152c691c&scoped=true"
import script from "./ThemeSwitch.vue?vue&type=script&lang=js"
export * from "./ThemeSwitch.vue?vue&type=script&lang=js"

import "./ThemeSwitch.vue?vue&type=style&index=0&id=152c691c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152c691c"]])

export default __exports__